// extracted by mini-css-extract-plugin
export default {"graph_wrapper":"Graph_graph_wrapper__e--0H","loading":"Graph_loading__uSkOl","operations_wrapper":"Graph_operations_wrapper__wbpkA","icons":"Graph_icons__+G0Q7"};